import styled from '@emotion/styled/macro';
import { em } from 'polished';

export const ProjectFeedItemHeader = styled.div({
  position: 'relative',
  width: em(228),
  height: em(156)
});
